import React from 'react';
import { Navigate, useNavigate, useParams } from 'react-router-dom';
import Layout from '../../components/Layout';
import ModuleCard from '../../ui/ModuleCard';
import EmptyState from '../../ui/EmptyState';
import { ICONS } from '../../ui/icon-map';
import { findNavGroup } from '../../ui/AppShell/navigation';
import { useVisibleNav } from '../../ui/AppShell/AppShell';
import { openFresh } from '../../ui/AppShell/freshNav';

/**
 * Section page (/section/:groupId): the breadcrumb and sidebar group label ("Operations", "Fleet" …)
 * open this page, which lists every module of that group the user can use.
 */
export default function SectionPage() {
    const { groupId } = useParams();
    const navigate = useNavigate();
    const group = findNavGroup(groupId);
    const visible = useVisibleNav().find((g) => g.id === groupId);

    if (!group) return <Navigate to="/" replace />;

    const items = visible ? visible.items : [];

    return (
        <Layout title={group.label} subtitle={group.description}>
            {items.length === 0 ? (
                <EmptyState icon={ICONS.lock} title="No modules available" description="You do not have access to any module in this section." />
            ) : (
                <div className="w-full max-w-6xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
                    {items.map((item) => (
                        <ModuleCard
                            key={item.id}
                            title={item.label}
                            desc={item.description}
                            iconGlyph={item.icon}
                            onClick={() => openFresh(navigate, item.path)}
                        />
                    ))}
                </div>
            )}
        </Layout>
    );
}
